var map = {
	"./bash": 1814,
	"./java": 1815,
	"./json": 1816,
	"./julia": 1817,
	"./python": 1818,
	"./r": 1819,
	"./rust": 1820,
	"./scala": 1821,
	"./shell": 1822,
	"./sql": 1823,
	"./xml": 1824,
	"./yaml": 1825
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1813;